var _style, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _polygon5, _polygon6, _path5, _path6, _polygon7, _polygon8, _polygon9, _polygon0, _path7, _path8, _path9, _path0, _polygon1, _polygon10, _polygon11, _polygon12, _path1, _polygon13, _path10, _polygon14, _path11, _polygon15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAxianBlanc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nav-link logo-axian-gris",
    id: "Logo_x5F_AXIAN",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.6 88",
    style: {
      enableBackground: "new 0 0 210.6 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .AXst0{fill:#FFFFFF;}\n        .AXst1{fill:#FFFFFF;}\n    ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "11.5,84.2 3.2,84.2 3.2,72.4 5,72.4 5,82.7 11.5,82.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "15.7,77.3 21.5,77.3 21.5,78.9 15.7,78.9 15.7,82.7 22.5,82.7 22.5,84.2 13.8,84.2 13.8,72.4          22.5,72.4 22.5,73.9 15.7,73.9 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "30.3,73.9 30.3,84.2 28.4,84.2 28.4,73.9 24.6,73.9 24.6,72.4 34.1,72.4 34.1,73.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "36.5,71.5 38.2,71.5 36.7,75.5 35.8,75.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M48.2,74.4c-1.1-0.4-2.3-0.7-3.5-0.7c-2,0-3,0.6-3,1.7c0,2.9,7.2,1,7.2,5.5c0,2.3-1.9,3.6-5.3,3.6         c-1.4,0-2.7-0.2-3.9-0.8l0.3-1.5c1.1,0.5,2.3,0.7,3.5,0.7c2.2,0,3.4-0.7,3.4-1.9c0-2.9-7.2-1-7.2-5.5c0-2.2,1.8-3.4,4.9-3.4         c1.3,0,2.6,0.3,3.8,0.8L48.2,74.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M66.1,83.5c-1.3,0.6-2.7,1-4.2,1c-4.1,0-5.5-2.6-5.5-6.1s1.4-6.2,5.4-6.2c1.3,0,2.6,0.3,3.8,0.8l-0.3,1.5         c-1-0.4-2.1-0.6-3.2-0.7c-2.6,0-3.8,1.6-3.8,4.6s1.2,4.4,3.8,4.4c0.7,0,1.4-0.1,2.1-0.3v-4h1.9L66.1,83.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M73.8,78.4c1.8,0,2.7-0.7,2.7-2.2S75.6,74,73.8,74H71v4.5h2.8V78.4z M71,79.9v4.3h-1.9V72.4H74         c2.9,0,4.4,1.3,4.4,3.8c0,2-0.9,3.2-2.8,3.6l3,4.5h-2.2L73.6,80L71,79.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M85.9,82.8c2.3,0,3.3-1.4,3.3-4.8c0-3-0.9-4.3-3.3-4.3c-2.3,0-3.3,1.3-3.3,4.7C82.6,81.5,83.5,82.9,85.9,82.8         M91.1,78.2c0,2.9-0.8,6.2-5.3,6.2s-5.2-3.1-5.2-6.1s0.9-6.2,5.3-6.2S91.1,75.3,91.1,78.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "104.9,84.2 102.5,84.2 100.1,74.3 97.7,84.2 95.3,84.2 92.8,72.4 94.7,72.4 96.7,82.3 98.9,72.4          101.3,72.4 103.6,82.3 105.6,72.4 107.5,72.4 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "120,73.9 120,84.2 118.1,84.2 118.1,73.9 114.3,73.9 114.3,72.4 123.8,72.4 123.8,73.9 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M130.6,82.8c2.3,0,3.3-1.4,3.3-4.8c0-3-0.9-4.3-3.3-4.3c-2.3,0-3.3,1.3-3.3,4.7         C127.3,81.5,128.2,82.9,130.6,82.8 M135.8,78.2c0,2.9-0.8,6.2-5.3,6.2s-5.2-3.1-5.2-6.1s0.9-6.2,5.3-6.2S135.8,75.2,135.8,78.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M147.7,83.5c-1.3,0.6-2.7,1-4.2,1c-4.1,0-5.5-2.6-5.5-6.1s1.4-6.2,5.4-6.2c1.3,0,2.6,0.3,3.8,0.8l-0.3,1.5         c-1-0.4-2.1-0.6-3.3-0.7c-2.6,0-3.8,1.6-3.8,4.6s1.2,4.4,3.8,4.4c0.7,0,1.4-0.1,2.1-0.3v-4h1.9L147.7,83.5z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "152.6,77.3 158.5,77.3 158.5,78.9 152.6,78.9 152.6,82.7 159.5,82.7 159.5,84.2 150.8,84.2 150.8,72.4          159.5,72.4 159.5,73.9 152.6,73.9 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "167.2,73.9 167.2,84.2 165.3,84.2 165.3,73.9 161.6,73.9 161.6,72.4 171,72.4 171,73.9 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "182.8,84.2 181,84.2 181,78.9 175.3,78.9 175.3,84.2 173.4,84.2 173.4,72.4 175.3,72.4 175.3,77.4          181,77.4 181,72.4 182.8,72.4 "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst0",
    points: "188.1,77.3 193.9,77.3 193.9,78.9 188.1,78.9 188.1,82.7 194.9,82.7 194.9,84.2 186.2,84.2 186.2,72.4          194.9,72.4 194.9,73.9 188.1,73.9 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "AXst0",
    d: "M202.1,78.4c1.8,0,2.7-0.7,2.7-2.2s-0.9-2.2-2.7-2.2h-2.8v4.5h2.8V78.4z M199.4,79.9v4.3h-1.9V72.4h4.9         c2.9,0,4.3,1.3,4.3,3.8c0,2-0.9,3.2-2.7,3.6l3,4.5h-2.2L202,80L199.4,79.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M7.6,47.2L3.9,58.1h11.9c0,0,2-6,4.3-13.3L7.6,47.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M23.2,35c2.3-7.3,4.3-13.8,4.5-15h0.2c0.2,1.2,2,7,4.2,13.7l12-1.7L35,6.2H21.5L11.2,36.7L23.2,35z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M34.8,42c2.6,7.9,5,15.1,5.3,16l8.4-13.6l-1.7-4.7L34.8,42z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "79.5,27 91.7,6.2 78.1,6.2 68.8,23.1 59.3,6.2 45.5,6.2 59.7,29.8 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "57.1,37.7 44.6,58.1 58.7,58.1 68.6,40.6 78.4,58.1 93.5,58.1 78,33.7 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "107.8,23 107.8,6.2 95.8,6.2 95.8,24.7 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "95.8,30.3 95.8,58.1 107.8,58.1 107.8,28 "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M120.7,25.5l-11,32.6h11.9c0,0,8.3-25.5,11-34.9L120.7,25.5z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "144.9,17.8 140.9,6.2 127.3,6.2 122.3,21 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M134.5,22.9C137.2,32,146,58.1,146,58.1h13.1L146,20.7L134.5,22.9z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "205.1,9.2 205.1,6.2 193.6,6.2 193.6,10.9 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "AXst1",
    d: "M193.6,11.6v11.7c0,4.9,0.2,11.8,0.5,16.2c-1.8-4-4-8.5-6.3-12.8l-7-12.7l-19.7,3.8v40.3h11.5V38.3         c0-4.9-0.2-10.2-0.4-14c1.6,3.9,3.4,7.7,5.4,11.4l12.2,22.4h15.3V9.3L193.6,11.6z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "AXst1",
    points: "180.1,12.8 176.4,6.2 161.1,6.2 161.1,15.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAxianBlanc);
export default __webpack_public_path__ + "static/media/logo_axian_blanc.0f65d65772855e7f7a8299ed3265e5e4.svg";
export { ForwardRef as ReactComponent };